import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'uri'
})
export class UriPipe implements PipeTransform {

  constructor ( private domSanitizer: DomSanitizer ) {}

  transform(value: string): any {
    return this.domSanitizer.bypassSecurityTrustHtml(value);
  }

}
